import { Wager } from "../types";
import WagerListItem from "./WagerListItem";

interface WagerListProps {
  wagers: Wager[];
}

export default function WagerList(props: WagerListProps) {
  return (
    <>
      {props.wagers.map((wager, index) => (
        <WagerListItem wager={wager} key={index} />
      ))}
    </>
  );
}
